// angular
// .module("HeroPRO")
// .factory("ResourcesFactory", resourcesFactory);

import _ from 'lodash';

/* @ngInject */
export default function resourcesFactory($http, $sce, HPConfig, PermissionsFactory) {
    const isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    const isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    const resourcePages = [
        {
            pageName: 'videos',
            pageDisplayName: 'Videos',
            isEnabled: isSolicitor,
        },
        {
            pageName: 'marketing',
            pageDisplayName: 'Marketing Materials',
            isEnabled: isSolicitor,
        },
        {
            pageName: 'participant',
            pageDisplayName: 'Participant Resources',
            isEnabled: isAdvertiser,
        },
        {
            pageName: 'documents',
            pageDisplayName: 'Documents',
            isEnabled: isSolicitor,
        },
        {
            pageName: 'map',
            pageDisplayName: 'HERO Map',
            isEnabled: true,
        },
        {
            pageName: 'products',
            pageDisplayName: 'Product Lookup',
            isEnabled: false,
        },
        {
            pageName: 'pace',
            pageDisplayName: 'The Future of PACE and HERO',
            isEnabled: true,
        },
    ];

    const resourceVideos = [
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/GYKpAJai0NU?rel=0&amp;showinfo=0'),
            videoTitle: 'Why Contractors Choose the HERO Program',
            videoDescription: 'See how contractors are benefiting from the HERO Program.',
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/IypViqe9Qnw?rel=0&amp;showinfo=0'),
            videoTitle: 'How the HERO Program Works',
            videoDescription: 'Video providing an overview of how financing works and program benefits.',
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/A8pcrT5pf2c?rel=0&amp;showinfo=0'),
            videoTitle: 'How the HERO Program Works - Spanish',
            videoDescription: 'Video en español que proporciona una visión general sobre cómo funciona el financiamiento y los beneficios del programa.',
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/9KjjU-Kh4js?rel=0&amp;showinfo=0'),
            videoTitle: 'HERO for Windows',
            videoDescription: 'The ins and outs of HERO Financing as it relates to Windows.',
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/Eec35VQR3ss?rel=0&amp;showinfo=0'),
            videoTitle: 'HERO for HVAC',
            videoDescription: 'The ins and outs of HERO Financing as it relates to Heating and Air Conditioning Systems.',
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/45HHe9EGINE?rel=0&amp;showinfo=0'),
            videoTitle: 'HERO Registered Contractors on the eSign Feature',
            videoDescription: "HERO's esign feature makes the process even easier.",
        },
        {
            videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/Ubb5-nKYbOU?rel=0&amp;showinfo=0'),
            videoTitle: 'HERO Celebrates Carini Heating & Air Conditioning Expansion',
            videoDescription: 'View how Carini Heating & Air grew their business with HERO.',
        },
    ];

    function getResourcePages() {
        return _.filter(resourcePages, page => page.isEnabled === true);
    }

    function getResourceVideos() {
        return resourceVideos;
    }

    function sproutLoudHandShake() {
        return $http.get(`${HPConfig.heroProApi}SproutLoud/HandShake`);
    }

    return {
        getResourcePages,
        getResourceVideos,
        sproutLoudHandShake,
    };
}



// WEBPACK FOOTER //
// ./src/app/resources/resourcesFactory.js